import { GaugeUnits } from 'types/gauge';

export const MNEMONICS = {
  WOBAV: 'WOBAV',
  HKLDAV: 'HKLDAV',
  PRESPUMPPAV: 'PRESPUMPPAV',
  FLOWINAV: 'FLOWINAV',
  FLOWIN_BST: 'FLOWINBST',
  BITDEP: 'BITDEP',
  DEPTH: 'DEPTH',
  BLOCK_POSITION: 'POSBLOCK',
  ROPAV: 'ROPAV',
  RPM: 'RPMAV',
  TQAV: 'TQAV',
  WTMUDINAV: 'WTMUDINAV',
  ECDPWD: 'ECDPWD',
  VBITDEP: 'VBITDEP',
  VDEPTH: 'VDEPTH',
  INCC: 'INCC',
  AZC: 'AZC',
  GASOUTAV: 'GASOUTAV',
  TEMP_MUD_OUT: 'TEMPMUDOUTAV',
  TTVOL01: 'TTVOL01',
  TTVOL02: 'TTVOL02',
  ACTIVE_VOLUME: 'TVOLACT',
  FLOWOUTAV: 'FLOWOUTAV',
  FLOWOUTPC: 'FLOWOUTPC',
  TVOL01: 'TVOL01',
  TVOL02: 'TVOL02',
  TVOL03: 'TVOL03',
  TVOL04: 'TVOL04',
  TVOL05: 'TVOL05',
  TVOL06: 'TVOL06',
  TVOL07: 'TVOL07',
  TVOL08: 'TVOL08',
  TVOL09: 'TVOL09',
  TVOL10: 'TVOL10',
  TVOL11: 'TVOL11',
  TVOL12: 'TVOL12',
  TVOL13: 'TVOL13',
  TVOL14: 'TVOL14',
  TVOL15: 'TVOL15',
  TVOL16: 'TVOL16',
  TVOL17: 'TVOL17',
  TVOL18: 'TVOL18',
  TVOL19: 'TVOL19',
  TVOL20: 'TVOL20',
  TVOL21: 'TVOL21',
  TVOL22: 'TVOL22',
  TVOL23: 'TVOL23',
  TVOL24: 'TVOL24',
  TVOL25: 'TVOL25',
  TVOL26: 'TVOL26',
  TVOL27: 'TVOL27',
  TVOL28: 'TVOL28',
  TVOL29: 'TVOL29',
  TVOL30: 'TVOL30',
  PRESDROPMOTOR: 'PRESDROPMOTOR',
  TVOLCACT: 'TVOLCACT',
  METH: 'METH',
  ETH: 'ETH',
  PRP: 'PRP',
  IBUT: 'IBUT',
  NBUT: 'NBUT',
  IPEN: 'IPEN',
  NPEN: 'NPEN',
  FORMDENSITY: 'FORMDENSITY',
  SSR: 'SSR',
} as const;

export type Mnemonic = (typeof MNEMONICS)[keyof typeof MNEMONICS];

export const ROP_QATAR_MNEMONICS = {
  WOBAV: MNEMONICS.WOBAV,
  PRESPUMPPAV: MNEMONICS.PRESPUMPPAV,
  FLOWINAV: MNEMONICS.FLOWINAV,
  RPM: MNEMONICS.RPM,
  TQAV: MNEMONICS.TQAV,
  ECDPWD: MNEMONICS.ECDPWD,
  PRESDROPMOTOR: MNEMONICS.PRESDROPMOTOR,
  FORMDENSITY: MNEMONICS.FORMDENSITY,
} as const;

export type RopQatarMnemonics = (typeof ROP_QATAR_MNEMONICS)[keyof typeof ROP_QATAR_MNEMONICS];

export const chromatographyMnemonics = [
  { mnemonic: MNEMONICS.METH, label: 'C1' },
  { mnemonic: MNEMONICS.ETH, label: 'C2' },
  { mnemonic: MNEMONICS.PRP, label: 'C3' },
  { mnemonic: MNEMONICS.IBUT, label: 'IC4' },
  { mnemonic: MNEMONICS.NBUT, label: 'NC4' },
  { mnemonic: MNEMONICS.IPEN, label: 'IC5' },
  { mnemonic: MNEMONICS.NPEN, label: 'NC5' },
];

export const KPI_NAMES_MNNEMONICS_MAPPING = {
  [MNEMONICS.DEPTH]: { name: 'Hole depth (MD)', precision: 1 },
  [MNEMONICS.BITDEP]: { name: 'Bit depth (MD)', precision: 1 },
  [MNEMONICS.VDEPTH]: { name: 'Hole depth (TVD)', precision: 1 },
  [MNEMONICS.VBITDEP]: { name: 'Bit depth (TVD)', precision: 1 },
  [MNEMONICS.RPM]: { name: 'Surface RPM', precision: 0, shortName: 'RPM' },
  [MNEMONICS.ECDPWD]: { name: 'Av. ECD', precision: 1 },
  [MNEMONICS.GASOUTAV]: { name: 'Av. Gas out', precision: 1 },
  [MNEMONICS.HKLDAV]: { name: 'Av. Hook load', precision: 2 },
  [MNEMONICS.WTMUDINAV]: { name: 'Av. Mud weight IN', precision: 2 },
  [MNEMONICS.PRESPUMPPAV]: { name: 'Av. SPP', precision: 0 },
  [MNEMONICS.TQAV]: { name: 'Av. Surface torque', precision: 0, shortName: 'Torque' },
  [MNEMONICS.WOBAV]: { name: 'Av. WOB', precision: 0, shortName: 'WOB' },
  [MNEMONICS.TVOLCACT]: { name: 'Active Volume +/-', precision: 1 },
  [MNEMONICS.PRESDROPMOTOR]: { name: 'Diff. Pressure', precision: 0 },
  [MNEMONICS.FLOWINAV]: { name: 'Flow In', precision: 0 },
  [MNEMONICS.FLOWOUTAV]: { name: 'Flow Out', precision: 1 },
  [MNEMONICS.FLOWOUTPC]: { name: 'Flow Out (%)', precision: 1 },
  [MNEMONICS.FORMDENSITY]: { name: 'Formation density', precision: 1, shortName: 'F. DENSITY' },
};

export enum Gauges {
  TRIPPING_M_H = 'TRIPPING_M_H',
  TRIPPING_S_H = 'TRIPPING_S_H',
  DRILLING = 'DRILLING',
}

export enum Widgets {
  WIDGET_ROP_OPTIMIZATION = 'WIDGET_ROP_OPTIMIZATION',
}

export const KPI_NAMES_GAUGE_MAPPING: Record<Gauges, { name: string; precision: number }> = {
  [Gauges.TRIPPING_M_H]: { name: `Tripping (${GaugeUnits.METER_PER_HOUR})`, precision: 1 },
  [Gauges.TRIPPING_S_H]: { name: `Tripping (${GaugeUnits.STAND_PER_HOUR})`, precision: 1 },
  [Gauges.DRILLING]: { name: 'ROP', precision: 1 },
};

export const WIDGET_NAMES_MAPPING = {
  [Widgets.WIDGET_ROP_OPTIMIZATION]: { name: 'ROP optimization' },
};

export type KpiItem = Mnemonic | Gauges | Widgets;
